import { gql } from '@apollo/client';

export const UPDATE_USER_PROFILE = gql`
  mutation UPDATE_USER_PROFILE($userProfile: UserProfileInput!) {
    updateUserProfile(userProfile: $userProfile)
  }
`;
